import types from '../types';
import createReducer from '../utils/createReducer';
import INITIAL_STATE from './initialState';

const initialState = INITIAL_STATE.toast;

export default createReducer(initialState, {
  [types.toast.SHOW_TOAST]: (state, action) => {
    let arr = [...state.toasts];
    arr.push({
      message: action.payload.message,
      id: `${new Date().getTime()}`,
      time: action.payload.time
    });
    return {
      ...state,
      toasts: arr
    };
  },
  [types.toast.HIDE_TOAST]: (state, action) => {
    let arr = [...state.toasts].filter(toast => toast.id != action.payload.id);
    return {
      ...state,
      toasts: arr
    };
  },
  [types.app.SIGN_OUT_USER_SUCCESS]: (state, action) => {
    for (const key in initialState) {
      state[key] = initialState[key];
    }
  }
});
